import React from 'react';
import { useTranslation } from "react-i18next";

/**
 * FormError - Atomic component for displaying form field errors
 * @param {Object} props
 * @param {string} props.message - Error message to display
 * @param {string} props.className - Additional CSS classes
 */
export const FormError = ({ message, className = '' }) => {
    const { t } = useTranslation();
    if (!message) return null;

    // Attempt to translate the message. If it's a key in our translation files, it will be translated.
    // If not, it will return the original message.
    const translatedMessage = t(message, { defaultValue: message });

    return (
        <span className={`text-red-500 text-xs ${className}`}>
            {translatedMessage}
        </span>
    );
};

export default FormError;
